var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-5 px-7 relative"},[_c('div',{staticClass:"text-lg text-gray-700 pb-3 border-b border-gray-500"},[_vm._v("隐私协议")]),_c('div',{staticClass:"mt-6"},[_c('iframe',{staticClass:"w-full",staticStyle:{"height":"8700px"},attrs:{"src":"https://game.7li.cn/static/download/privacy.html","scrolling":"no","frameborder":"0"}})])])
}]

export { render, staticRenderFns }